import { WebHaptics } from 'web-haptics';

type HapticStyle =
  | 'light'
  | 'medium'
  | 'heavy'
  | 'success'
  | 'warning'
  | 'error'
  | 'selection'
  | 'nudge';

let haptics: WebHaptics | null = null;

function getHaptics(): WebHaptics | null {
  if (typeof window === 'undefined') {
    return null;
  }

  if (!haptics) {
    haptics = new WebHaptics();
  }

  return haptics;
}

export function isHapticsSupported(): boolean {
  return WebHaptics.isSupported;
}

export function haptic(style: HapticStyle = 'medium'): void {
  const instance = getHaptics();
  if (!instance) return;

  void instance.trigger(style);
}

export const hapticLight = () => haptic('light');
export const hapticMedium = () => haptic('medium');
export const hapticHeavy = () => haptic('heavy');
export const hapticSuccess = () => haptic('success');
export const hapticWarning = () => haptic('warning');
export const hapticError = () => haptic('error');
export const hapticSelection = () => haptic('selection');
export const hapticNudge = () => haptic('nudge');
